import React from "react";
import Image from "next/image";
import { Blur, Remote } from "@/api/loaderRemote";

const IncludedServices = ({ includedServices }) => {
  return (
    <div className="flex flex-col xsm:gap-3 gap-2.5">
      <span className="text-xl font-bold leading-normal text-themeBlack">
        Fiyata dahil olan hizmetler
      </span>
      <div className="flex flex-wrap md:gap-3 gap-1.5">
        {includedServices.map((item) => (
          <div
            key={item.id}
            className="inline-flex items-center gap-2.5 bg-white xsm:py-3 py-2.5 xsm:px-5 px-4 rounded-md border border-[#E7EDF4]"
          >
            <Image
              src={item.icon}
              width={24}
              height={24}
              alt={item.baslik}
              loader={Remote}
              blurDataURL={Blur(item.icon)}
              className="object-contain"
            />
            <span className="text-sm font-medium leading-4 text-themeBlack">
              {item.baslik}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IncludedServices;
